const USER_ACTION_TYPES = {
  SET_CURRENT_USER: "SET_CURRENT_USER",
  CHECK_USER_SESSION: "CHECK_USER_SESSION",
  GOOGLE_SIGNIN_START: "GOOGLE_SIGNIN_START",
  EMAIL_SIGNIN_START: "EMAIL_SIGNIN_START",
  SIGNIN_SUCCESS: "SIGNIN_SUCCESS",
  SIGNIN_FAILURE: "SIGNIN_FAILURE",
  SIGNUP_START: "SIGNUP_START",
  SIGNUP_FAILURE: "SIGNUP_FAILURE",
  SIGNOUT_START: "SIGNOUT_START",
  SIGNOUT_SUCCESS: "SIGNOUT_SUCCESS",
  SIGNOUT_FAILURE: "SIGNOUT_FAILURE",
};

export default USER_ACTION_TYPES;
